import * as React from 'react';
import { Contract, Role, User } from 'tree-wallet-client';
import { userHasRole, UserRoles } from '../../Repository/UserRepository';
import { allowedRoles as formPermissions } from '../../Pages/FormPage/FormPage';
import { allowedRoles as listPermissions } from '../../Pages/MapPage/MapPage';
import { isAllowed, logout } from '../../Service/AuthService';
import CompassTwoTone from '@ant-design/icons/CompassTwoTone';
import PlusCircleTwoTone from '@ant-design/icons/PlusCircleTwoTone';
import SmileTwoTone from '@ant-design/icons/SmileTwoTone';
import { GlobalContext } from "../../Contexts/GlobalContext";
import { downloadKML } from '../../Repository/TreeRepository';
import { Filter } from '../../Pages/MapPage/MapPage';
import * as SyncService from '../../Service/SyncService';
//import * as ContractRepository from '../../Repository/ContractRepository';

export interface SiteMenuProps {
  user?: User;
  contract?: Contract;
  setShowLoader: (show: boolean) => void;
  setShowOfflineSync?: (show: boolean) => void;
  setOfflineSyncCurrent?: (current: number) => void;
  setOfflineSyncTotal?: (total: number) => void;
  filter?: Filter;
}

interface SiteMenuState {
  opened: boolean;
}

export const linkTypes = {
  link: 'link',
  btn: 'btn',
  logout: 'logout',
};

export default class SiteMenu extends React.Component<SiteMenuProps, SiteMenuState> {
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>;

  constructor(props: SiteMenuProps) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.downloadkmlfile = this.downloadkmlfile.bind(this);
    this.saveOffline = this.saveOffline.bind(this);
    this.state = {
      opened: false
    };
  }

  async saveOffline() {
    const { contracts } = this.context;
    const { setShowOfflineSync, setOfflineSyncCurrent, setOfflineSyncTotal } = this.props;

    if (!contracts || !setShowOfflineSync || !setOfflineSyncCurrent || !setOfflineSyncTotal) {
      return;
    }

    setShowOfflineSync(true);
    setOfflineSyncCurrent(0);
    setOfflineSyncTotal(0);

    try {
      await SyncService.syncValidatorPhotos(contracts, (current: number, total: number) => {
        setOfflineSyncCurrent(current);
        setOfflineSyncTotal(total);
      });
    } catch (error) {
      console.error('Error during offline sync:', error);
    } finally {
      // Small delay to show completion
      setTimeout(() => setShowOfflineSync(false), 1000);
    }
  }

  toggle() {
    const { opened } = this.state;
    this.setState({
      opened: !opened
    });
  }

  downloadkmlfile() {
    const { setShowLoader } = this.props;
    const { filter } = this.context;
    if (setShowLoader) {
      downloadKML(setShowLoader, filter);
      // Removed this.toggle() to prevent menu from closing on desktop
    }
  }

  shouldDisplayLink(user: any, contract: Contract | undefined, link: any) {
    if (link.public) {
      return true;
    }
    if (!user && !link.public) {
      return false;
    }
    if (user && userHasRole(user.roles, UserRoles.Admin.name)) {
      return true;
    }
    if (link.type === linkTypes.logout) {
      return true;
    }

    const userRoles = user?.roles;
    return isAllowed([
      ...(contract?.roles || []),
      ...userRoles,
    ], link.permissions);
  }

  getLinks() {
    const { user, contract } = this.props;

    const links = [];
    if (contract) {
      links.push({ icon: <PlusCircleTwoTone />, type: linkTypes.link, link: `/${contract.id}/form`, onClick: this.toggle, permissions: formPermissions, text: 'New Tree' });
      links.push({ icon: <CompassTwoTone />, type: linkTypes.link, link: `/${contract.id}/list`, onClick: this.toggle, permissions: listPermissions, text: 'Tree Map' });
      
      /*
      // Add Save Offline link below Tree Map
      links.push({ 
        icon: <PlusCircleTwoTone />, 
        type: linkTypes.btn, 
        link: `#save-offline`, 
        onClick: this.saveOffline, 
        permissions: [ContractRepository.roles.Validator, ContractRepository.roles.Agent], 
        text: 'Save Offline' 
      });
      */
    }

    const adminLinks = [];
    if (user && userHasRole(user.roles, UserRoles.Admin.name)) {
      adminLinks.push({ icon: <SmileTwoTone />, type: linkTypes.btn, link: `#`, onClick: this.downloadkmlfile, permissions: [UserRoles.Admin.name], text: 'Download KML' });
      adminLinks.push({ icon: <SmileTwoTone />, type: linkTypes.link, link: `/admin`, onClick: this.toggle, permissions: [UserRoles.Admin.name], text: 'Manage Users' });
      adminLinks.push({ icon: <SmileTwoTone />, type: linkTypes.link, link: `/admin/contracts`, onClick: this.toggle, permissions: [UserRoles.Admin], text: 'Manage Contracts' });
    }

    const globalLinks = [
      { icon: <SmileTwoTone />, type: linkTypes.logout, onClick: logout, permissions: Object.values(UserRoles.all).map((role: Role) => role.name), text: 'Logout' }
    ];

    const publicLinks = [];
    if (!user) {
      publicLinks.push({ icon: <SmileTwoTone />, type: linkTypes.link, public: true, link: '/public', text: 'Our trees' });
      publicLinks.push({ icon: <SmileTwoTone />, type: linkTypes.link, public: true, link: '/login', text: 'Login' });
    }

    if (!user) {
      return publicLinks;
    }

    return [...publicLinks, ...links, ...adminLinks, ...globalLinks];
  }
}
